var map = {
	"./fun-time/audio/karta1/1_hello.mp3": "cfc3",
	"./fun-time/audio/karta1/2_bye_bye.mp3": "d882",
	"./fun-time/audio/karta1/3_Tom.mp3": "04d3",
	"./fun-time/audio/karta1/4_Lisa.mp3": "abe9",
	"./fun-time/audio/karta2/10_yellow.mp3": "f446b",
	"./fun-time/audio/karta2/11_green.mp3": "4e9a",
	"./fun-time/audio/karta2/8_blue.mp3": "dab1",
	"./fun-time/audio/karta2/9_red.mp3": "b1cd",
	"./fun-time/background/strona_000.jpg": "8e8f",
	"./fun-time/background/strona_001.jpg": "aad8",
	"./fun-time/background/strona_002.jpg": "8a10",
	"./fun-time/background/strona_003.jpg": "e647",
	"./fun-time/background/strona_004.jpg": "db51",
	"./fun-time/background/strona_005.jpg": "a35d",
	"./fun-time/background/strona_006.jpg": "cb41",
	"./fun-time/background/strona_007.jpg": "d7e1",
	"./fun-time/background/strona_008.jpg": "2539",
	"./fun-time/background/strona_009.jpg": "d64a",
	"./fun-time/background/strona_010.jpg": "c7c5",
	"./fun-time/background/strona_011.jpg": "8436",
	"./fun-time/background/strona_end.jpg": "c24f",
	"./fun-time/background/strona_start.jpg": "3ba3",
	"./fun-time/config": "3937",
	"./fun-time/config/": "3937",
	"./fun-time/config/default/config_default": "7f34",
	"./fun-time/config/default/config_default.js": "7f34",
	"./fun-time/config/default/test": "608f",
	"./fun-time/config/default/test.js": "608f",
	"./fun-time/config/index": "3937",
	"./fun-time/config/index.js": "3937",
	"./fun-time/config/pages": "0830",
	"./fun-time/config/pages/": "0830",
	"./fun-time/config/pages/index": "0830",
	"./fun-time/config/pages/index.js": "0830",
	"./fun-time/config/pages/page000": "20bd",
	"./fun-time/config/pages/page000.js": "20bd",
	"./fun-time/config/pages/page001": "67f9",
	"./fun-time/config/pages/page001.js": "67f9",
	"./fun-time/config/pages/page002": "2d04",
	"./fun-time/config/pages/page002.js": "2d04",
	"./fun-time/config/pages/page003": "7d40",
	"./fun-time/config/pages/page003.js": "7d40",
	"./fun-time/config/pages/page004": "fe7f",
	"./fun-time/config/pages/page004.js": "fe7f",
	"./fun-time/config/pages/page005": "49c4",
	"./fun-time/config/pages/page005.js": "49c4",
	"./fun-time/config/pages/page006": "588a",
	"./fun-time/config/pages/page006.js": "588a",
	"./fun-time/config/pages/page007": "85ec",
	"./fun-time/config/pages/page007.js": "85ec",
	"./fun-time/config/pages/page008": "f048",
	"./fun-time/config/pages/page008.js": "f048",
	"./fun-time/config/pages/page009": "c4dc",
	"./fun-time/config/pages/page009.js": "c4dc",
	"./fun-time/config/pages/page010": "0579",
	"./fun-time/config/pages/page010.js": "0579",
	"./fun-time/config/pages/page011": "e64c",
	"./fun-time/config/pages/page011.js": "e64c",
	"./fun-time/config/pages/pageEnd": "35c8",
	"./fun-time/config/pages/pageEnd.js": "35c8",
	"./fun-time/config/pages/pageStart": "1024",
	"./fun-time/config/pages/pageStart.js": "1024",
	"./fun-time/config/subconfig": "a8e4",
	"./fun-time/config/subconfig.js": "a8e4",
	"./fun-time/films/base.png": "6766",
	"./fun-time/gallery/karta1/1_hello.jpg": "d64e",
	"./fun-time/gallery/karta1/2_bye_bye.jpg": "963f",
	"./fun-time/gallery/karta1/3_Tom.jpg": "9393",
	"./fun-time/gallery/karta1/4_Lisa.jpg": "75cc",
	"./fun-time/gallery/karta2/10_yellow.jpg": "195f",
	"./fun-time/gallery/karta2/11_green.jpg": "684c",
	"./fun-time/gallery/karta2/8_blue.jpg": "8b97",
	"./fun-time/gallery/karta2/9_red.jpg": "ffa6",
	"./fun-time/games": "0bc9",
	"./fun-time/games/": "0bc9",
	"./fun-time/games/index": "0bc9",
	"./fun-time/games/index.js": "0bc9",
	"./fun-time/games/page000_game0/audio": "d936",
	"./fun-time/games/page000_game0/audio/": "d936",
	"./fun-time/games/page000_game0/audio/5_rabbit.mp3": "4a2f",
	"./fun-time/games/page000_game0/audio/6_bear.mp3": "76ee",
	"./fun-time/games/page000_game0/audio/7_mole.mp3": "ad2e",
	"./fun-time/games/page000_game0/audio/index": "d936",
	"./fun-time/games/page000_game0/audio/index.js": "d936",
	"./fun-time/games/page000_game0/config": "1bfc",
	"./fun-time/games/page000_game0/config.js": "1bfc",
	"./fun-time/games/page000_game0/gameData.config": "f5c9",
	"./fun-time/games/page000_game0/gameData.config.js": "f5c9",
	"./fun-time/games/page000_game0/img": "f338",
	"./fun-time/games/page000_game0/img/": "f338",
	"./fun-time/games/page000_game0/img/audioOff.png": "658c",
	"./fun-time/games/page000_game0/img/audioOn.png": "25c3",
	"./fun-time/games/page000_game0/img/bcg.jpg": "942f",
	"./fun-time/games/page000_game0/img/index": "f338",
	"./fun-time/games/page000_game0/img/index.js": "f338",
	"./fun-time/games/page000_game1/audio": "b717",
	"./fun-time/games/page000_game1/audio/": "b717",
	"./fun-time/games/page000_game1/audio/12_purple.mp3": "9050",
	"./fun-time/games/page000_game1/audio/13_pink.mp3": "9d3f",
	"./fun-time/games/page000_game1/audio/14_orange.mp3": "7f76",
	"./fun-time/games/page000_game1/audio/index": "b717",
	"./fun-time/games/page000_game1/audio/index.js": "b717",
	"./fun-time/games/page000_game1/config": "60a7",
	"./fun-time/games/page000_game1/config.js": "60a7",
	"./fun-time/games/page000_game1/gameData.config": "408d",
	"./fun-time/games/page000_game1/gameData.config.js": "408d",
	"./fun-time/games/page000_game1/img": "c7e5",
	"./fun-time/games/page000_game1/img/": "c7e5",
	"./fun-time/games/page000_game1/img/audioOff.png": "42bb",
	"./fun-time/games/page000_game1/img/audioOn.png": "ae6e",
	"./fun-time/games/page000_game1/img/bcg.jpg": "8495",
	"./fun-time/games/page000_game1/img/index": "c7e5",
	"./fun-time/games/page000_game1/img/index.js": "c7e5",
	"./fun-time/games/page000_game2/audio": "5fff",
	"./fun-time/games/page000_game2/audio/": "5fff",
	"./fun-time/games/page000_game2/audio/10_yellow.mp3": "c902",
	"./fun-time/games/page000_game2/audio/11_green.mp3": "bf8c6",
	"./fun-time/games/page000_game2/audio/12_purple.mp3": "2a75",
	"./fun-time/games/page000_game2/audio/13_pink.mp3": "3c41",
	"./fun-time/games/page000_game2/audio/14_orange.mp3": "13ad",
	"./fun-time/games/page000_game2/audio/1_hello.mp3": "2798",
	"./fun-time/games/page000_game2/audio/2_bye_bye.mp3": "650e",
	"./fun-time/games/page000_game2/audio/3_Tom.mp3": "1aaf",
	"./fun-time/games/page000_game2/audio/4_Lisa.mp3": "fe3d",
	"./fun-time/games/page000_game2/audio/5_rabbit.mp3": "2b51",
	"./fun-time/games/page000_game2/audio/6_bear.mp3": "2a3c",
	"./fun-time/games/page000_game2/audio/7_mole.mp3": "54c0",
	"./fun-time/games/page000_game2/audio/8_blue.mp3": "59d8",
	"./fun-time/games/page000_game2/audio/9_red.mp3": "df37",
	"./fun-time/games/page000_game2/audio/index": "5fff",
	"./fun-time/games/page000_game2/audio/index.js": "5fff",
	"./fun-time/games/page000_game2/config": "246d",
	"./fun-time/games/page000_game2/config.js": "246d",
	"./fun-time/games/page000_game2/gameData.config": "d8c2",
	"./fun-time/games/page000_game2/gameData.config.js": "d8c2",
	"./fun-time/games/page000_game2/img": "cf61",
	"./fun-time/games/page000_game2/img/": "cf61",
	"./fun-time/games/page000_game2/img/audioOff.png": "555c",
	"./fun-time/games/page000_game2/img/audioOn.png": "6493",
	"./fun-time/games/page000_game2/img/bcg.jpg": "ae80",
	"./fun-time/games/page000_game2/img/index": "cf61",
	"./fun-time/games/page000_game2/img/index.js": "cf61",
	"./fun-time/games/page001_game0/audio": "cb8f",
	"./fun-time/games/page001_game0/audio/": "cb8f",
	"./fun-time/games/page001_game0/audio/Track_8_Story_1_Hello Lisa_.mp3": "e735",
	"./fun-time/games/page001_game0/audio/index": "cb8f",
	"./fun-time/games/page001_game0/audio/index.js": "cb8f",
	"./fun-time/games/page001_game0/audio/s1_1.mp3": "4608",
	"./fun-time/games/page001_game0/audio/s1_2.mp3": "552e",
	"./fun-time/games/page001_game0/audio/s1_3.mp3": "904e",
	"./fun-time/games/page001_game0/audio/s1_4.mp3": "3d14",
	"./fun-time/games/page001_game0/config": "b64d",
	"./fun-time/games/page001_game0/config.js": "b64d",
	"./fun-time/games/page001_game0/gameData.config": "d084",
	"./fun-time/games/page001_game0/gameData.config.js": "d084",
	"./fun-time/games/page001_game0/img": "9a25",
	"./fun-time/games/page001_game0/img/": "9a25",
	"./fun-time/games/page001_game0/img/bcg.jpg": "de83",
	"./fun-time/games/page001_game0/img/index": "9a25",
	"./fun-time/games/page001_game0/img/index.js": "9a25",
	"./fun-time/games/page001_game1/audio": "a83a",
	"./fun-time/games/page001_game1/audio/": "a83a",
	"./fun-time/games/page001_game1/audio/Track_11_Story_2_Colours.mp3": "625b",
	"./fun-time/games/page001_game1/audio/index": "a83a",
	"./fun-time/games/page001_game1/audio/index.js": "a83a",
	"./fun-time/games/page001_game1/audio/s2_1.mp3": "8ee0",
	"./fun-time/games/page001_game1/audio/s2_2.mp3": "6029",
	"./fun-time/games/page001_game1/audio/s2_3.mp3": "8e21",
	"./fun-time/games/page001_game1/audio/s2_4.mp3": "c209",
	"./fun-time/games/page001_game1/config": "d4f7",
	"./fun-time/games/page001_game1/config.js": "d4f7",
	"./fun-time/games/page001_game1/gameData.config": "9a6a",
	"./fun-time/games/page001_game1/gameData.config.js": "9a6a",
	"./fun-time/games/page001_game1/img": "5052",
	"./fun-time/games/page001_game1/img/": "5052",
	"./fun-time/games/page001_game1/img/bcg.jpg": "457f",
	"./fun-time/games/page001_game1/img/index": "5052",
	"./fun-time/games/page001_game1/img/index.js": "5052",
	"./fun-time/games/page002_game0/audio": "d95a",
	"./fun-time/games/page002_game0/audio/": "d95a",
	"./fun-time/games/page002_game0/audio/0_Dusty.mp3": "7b1e",
	"./fun-time/games/page002_game0/audio/3_Tom.mp3": "25a1",
	"./fun-time/games/page002_game0/audio/4_Lisa.mp3": "5938",
	"./fun-time/games/page002_game0/audio/M_Brilliant.mp3": "7372",
	"./fun-time/games/page002_game0/audio/M_Excellent.mp3": "30fc",
	"./fun-time/games/page002_game0/audio/M_Fantastic.mp3": "c29a",
	"./fun-time/games/page002_game0/audio/M_Great.mp3": "48ea",
	"./fun-time/games/page002_game0/audio/M_Perfect.mp3": "a383",
	"./fun-time/games/page002_game0/audio/M_Think again.mp3": "14e7",
	"./fun-time/games/page002_game0/audio/M_Try again.mp3": "2872",
	"./fun-time/games/page002_game0/audio/M_Very good.mp3": "7cac",
	"./fun-time/games/page002_game0/audio/M_Well done.mp3": "dec4",
	"./fun-time/games/page002_game0/audio/M_Work harder.mp3": "5829",
	"./fun-time/games/page002_game0/audio/click.mp3": "e322",
	"./fun-time/games/page002_game0/audio/index": "d95a",
	"./fun-time/games/page002_game0/audio/index.js": "d95a",
	"./fun-time/games/page002_game0/config": "6273",
	"./fun-time/games/page002_game0/config.js": "6273",
	"./fun-time/games/page002_game0/gameData.config": "5efd",
	"./fun-time/games/page002_game0/gameData.config.js": "5efd",
	"./fun-time/games/page002_game0/img": "4d81",
	"./fun-time/games/page002_game0/img/": "4d81",
	"./fun-time/games/page002_game0/img/audioOff.png": "5215",
	"./fun-time/games/page002_game0/img/audioOn.png": "5144",
	"./fun-time/games/page002_game0/img/bcg.webp": "adba",
	"./fun-time/games/page002_game0/img/dusty_g.png": "98db",
	"./fun-time/games/page002_game0/img/index": "4d81",
	"./fun-time/games/page002_game0/img/index.js": "4d81",
	"./fun-time/games/page002_game0/img/lisa_g.png": "d3f3",
	"./fun-time/games/page002_game0/img/tom_g.png": "cf81",
	"./fun-time/games/page002_game1/audio": "c431",
	"./fun-time/games/page002_game1/audio/": "c431",
	"./fun-time/games/page002_game1/audio/0_Dusty.mp3": "a7c9",
	"./fun-time/games/page002_game1/audio/3_Tom.mp3": "2a91",
	"./fun-time/games/page002_game1/audio/4_Lisa.mp3": "2448",
	"./fun-time/games/page002_game1/audio/M_Brilliant.mp3": "989f",
	"./fun-time/games/page002_game1/audio/M_Excellent.mp3": "71e7",
	"./fun-time/games/page002_game1/audio/M_Fantastic.mp3": "5100",
	"./fun-time/games/page002_game1/audio/M_Great.mp3": "55e8",
	"./fun-time/games/page002_game1/audio/M_Perfect.mp3": "4777",
	"./fun-time/games/page002_game1/audio/M_Think again.mp3": "5da2",
	"./fun-time/games/page002_game1/audio/M_Try again.mp3": "9dd3",
	"./fun-time/games/page002_game1/audio/M_Very good.mp3": "0aa7",
	"./fun-time/games/page002_game1/audio/M_Well done.mp3": "993e",
	"./fun-time/games/page002_game1/audio/M_Work harder.mp3": "8e29",
	"./fun-time/games/page002_game1/audio/click.mp3": "b933",
	"./fun-time/games/page002_game1/audio/index": "c431",
	"./fun-time/games/page002_game1/audio/index.js": "c431",
	"./fun-time/games/page002_game1/config": "8d25",
	"./fun-time/games/page002_game1/config.js": "8d25",
	"./fun-time/games/page002_game1/gameData.config": "4d77",
	"./fun-time/games/page002_game1/gameData.config.js": "4d77",
	"./fun-time/games/page002_game1/img": "80b1",
	"./fun-time/games/page002_game1/img/": "80b1",
	"./fun-time/games/page002_game1/img/1.png": "8bea",
	"./fun-time/games/page002_game1/img/2.png": "67d98",
	"./fun-time/games/page002_game1/img/audioOff.png": "3b80",
	"./fun-time/games/page002_game1/img/audioOn.png": "c808",
	"./fun-time/games/page002_game1/img/bcg.webp": "c958",
	"./fun-time/games/page002_game1/img/dusty_g.png": "05aa",
	"./fun-time/games/page002_game1/img/index": "80b1",
	"./fun-time/games/page002_game1/img/index.js": "80b1",
	"./fun-time/games/page002_game1/img/lisa_g.png": "f952",
	"./fun-time/games/page002_game1/img/tom_g.png": "fe4a",
	"./fun-time/games/page003_game1/audio": "6230",
	"./fun-time/games/page003_game1/audio/": "6230",
	"./fun-time/games/page003_game1/audio/5_rabbit.mp3": "df66",
	"./fun-time/games/page003_game1/audio/6_bear.mp3": "31a1",
	"./fun-time/games/page003_game1/audio/7_mole.mp3": "4815",
	"./fun-time/games/page003_game1/audio/M_Brilliant.mp3": "5c55",
	"./fun-time/games/page003_game1/audio/M_Excellent.mp3": "eab9",
	"./fun-time/games/page003_game1/audio/M_Fantastic.mp3": "46dd",
	"./fun-time/games/page003_game1/audio/M_Great.mp3": "7e49",
	"./fun-time/games/page003_game1/audio/M_Perfect.mp3": "43d1",
	"./fun-time/games/page003_game1/audio/M_Think again.mp3": "b24c",
	"./fun-time/games/page003_game1/audio/M_Try again.mp3": "d6b5",
	"./fun-time/games/page003_game1/audio/M_Very good.mp3": "003c",
	"./fun-time/games/page003_game1/audio/M_Well done.mp3": "a230",
	"./fun-time/games/page003_game1/audio/M_Work harder.mp3": "f5f6",
	"./fun-time/games/page003_game1/audio/click.mp3": "89a9",
	"./fun-time/games/page003_game1/audio/false.mp3": "ad18",
	"./fun-time/games/page003_game1/audio/index": "6230",
	"./fun-time/games/page003_game1/audio/index.js": "6230",
	"./fun-time/games/page003_game1/audio/true.mp3": "a7ca",
	"./fun-time/games/page003_game1/config": "583e",
	"./fun-time/games/page003_game1/config.js": "583e",
	"./fun-time/games/page003_game1/gameData.config": "41fc",
	"./fun-time/games/page003_game1/gameData.config.js": "41fc",
	"./fun-time/games/page003_game1/img": "da46",
	"./fun-time/games/page003_game1/img/": "da46",
	"./fun-time/games/page003_game1/img/audioOff.png": "9115",
	"./fun-time/games/page003_game1/img/audioOn.png": "e134",
	"./fun-time/games/page003_game1/img/b_1.png": "911d",
	"./fun-time/games/page003_game1/img/b_1_cross.png": "a551",
	"./fun-time/games/page003_game1/img/bcg.webp": "89d9",
	"./fun-time/games/page003_game1/img/g_1.png": "50e2",
	"./fun-time/games/page003_game1/img/g_1_tick.png": "991d",
	"./fun-time/games/page003_game1/img/index": "da46",
	"./fun-time/games/page003_game1/img/index.js": "da46",
	"./fun-time/games/page003_game2/audio": "0424",
	"./fun-time/games/page003_game2/audio/": "0424",
	"./fun-time/games/page003_game2/audio/index": "0424",
	"./fun-time/games/page003_game2/audio/index.js": "0424",
	"./fun-time/games/page003_game2/config": "bb8e",
	"./fun-time/games/page003_game2/config.js": "bb8e",
	"./fun-time/games/page003_game2/gameData.config": "c9c3",
	"./fun-time/games/page003_game2/gameData.config.js": "c9c3",
	"./fun-time/games/page003_game2/img": "1bca",
	"./fun-time/games/page003_game2/img/": "1bca",
	"./fun-time/games/page003_game2/img/b_2.png": "9049",
	"./fun-time/games/page003_game2/img/b_2_cross.png": "5a6a",
	"./fun-time/games/page003_game2/img/bcg.webp": "0b52",
	"./fun-time/games/page003_game2/img/g_2.png": "2896",
	"./fun-time/games/page003_game2/img/g_2_tick.png": "c51c",
	"./fun-time/games/page003_game2/img/index": "1bca",
	"./fun-time/games/page003_game2/img/index.js": "1bca",
	"./fun-time/games/page003_game3/audio": "2eaa",
	"./fun-time/games/page003_game3/audio/": "2eaa",
	"./fun-time/games/page003_game3/audio/index": "2eaa",
	"./fun-time/games/page003_game3/audio/index.js": "2eaa",
	"./fun-time/games/page003_game3/config": "46a3",
	"./fun-time/games/page003_game3/config.js": "46a3",
	"./fun-time/games/page003_game3/gameData.config": "47520",
	"./fun-time/games/page003_game3/gameData.config.js": "47520",
	"./fun-time/games/page003_game3/img": "05d8",
	"./fun-time/games/page003_game3/img/": "05d8",
	"./fun-time/games/page003_game3/img/b_3.png": "caa2",
	"./fun-time/games/page003_game3/img/b_3_cross.png": "d84a",
	"./fun-time/games/page003_game3/img/bcg.webp": "a3f2",
	"./fun-time/games/page003_game3/img/g_3.png": "11e9",
	"./fun-time/games/page003_game3/img/g_3_tick.png": "a71e",
	"./fun-time/games/page003_game3/img/index": "05d8",
	"./fun-time/games/page003_game3/img/index.js": "05d8",
	"./fun-time/games/page004_game0/audio": "f9a4",
	"./fun-time/games/page004_game0/audio/": "f9a4",
	"./fun-time/games/page004_game0/audio/5_rabbit.mp3": "d309",
	"./fun-time/games/page004_game0/audio/6_bear.mp3": "94d1",
	"./fun-time/games/page004_game0/audio/7_mole.mp3": "aa21",
	"./fun-time/games/page004_game0/audio/M_Brilliant.mp3": "8077",
	"./fun-time/games/page004_game0/audio/M_Excellent.mp3": "3b7a",
	"./fun-time/games/page004_game0/audio/M_Fantastic.mp3": "992a",
	"./fun-time/games/page004_game0/audio/M_Great.mp3": "d9af",
	"./fun-time/games/page004_game0/audio/M_Perfect.mp3": "50ad",
	"./fun-time/games/page004_game0/audio/M_Think again.mp3": "1110",
	"./fun-time/games/page004_game0/audio/M_Try again.mp3": "ea3a",
	"./fun-time/games/page004_game0/audio/M_Very good.mp3": "2dd9",
	"./fun-time/games/page004_game0/audio/M_Well done.mp3": "7b81",
	"./fun-time/games/page004_game0/audio/M_Work harder.mp3": "98a6",
	"./fun-time/games/page004_game0/audio/click.mp3": "ec4c",
	"./fun-time/games/page004_game0/audio/index": "f9a4",
	"./fun-time/games/page004_game0/audio/index.js": "f9a4",
	"./fun-time/games/page004_game0/config": "c073",
	"./fun-time/games/page004_game0/config.js": "c073",
	"./fun-time/games/page004_game0/gameData.config": "d686",
	"./fun-time/games/page004_game0/gameData.config.js": "d686",
	"./fun-time/games/page004_game0/img": "9779",
	"./fun-time/games/page004_game0/img/": "9779",
	"./fun-time/games/page004_game0/img/audioOff.png": "6462",
	"./fun-time/games/page004_game0/img/audioOn.png": "42e2",
	"./fun-time/games/page004_game0/img/bcg.webp": "0025",
	"./fun-time/games/page004_game0/img/bear.png": "cf33",
	"./fun-time/games/page004_game0/img/dusty.png": "8a78",
	"./fun-time/games/page004_game0/img/folia.png": "b995",
	"./fun-time/games/page004_game0/img/index": "9779",
	"./fun-time/games/page004_game0/img/index.js": "9779",
	"./fun-time/games/page004_game0/img/lisa.png": "0036",
	"./fun-time/games/page004_game0/img/mole.png": "9a91",
	"./fun-time/games/page004_game0/img/rabbit.png": "86c4",
	"./fun-time/games/page004_game0/img/tom.png": "3068",
	"./fun-time/games/page004_game1/audio": "6058",
	"./fun-time/games/page004_game1/audio/": "6058",
	"./fun-time/games/page004_game1/audio/5_rabbit.mp3": "67f95",
	"./fun-time/games/page004_game1/audio/6_bear.mp3": "c8a1",
	"./fun-time/games/page004_game1/audio/7_mole.mp3": "4bf3",
	"./fun-time/games/page004_game1/audio/M_Brilliant.mp3": "f771",
	"./fun-time/games/page004_game1/audio/M_Excellent.mp3": "040a",
	"./fun-time/games/page004_game1/audio/M_Fantastic.mp3": "4ff5",
	"./fun-time/games/page004_game1/audio/M_Great.mp3": "9e90",
	"./fun-time/games/page004_game1/audio/M_Perfect.mp3": "525a",
	"./fun-time/games/page004_game1/audio/M_Think again.mp3": "2ac4",
	"./fun-time/games/page004_game1/audio/M_Try again.mp3": "94a2",
	"./fun-time/games/page004_game1/audio/M_Very good.mp3": "48b6",
	"./fun-time/games/page004_game1/audio/M_Well done.mp3": "565d",
	"./fun-time/games/page004_game1/audio/M_Work harder.mp3": "c48a",
	"./fun-time/games/page004_game1/audio/click.mp3": "d37b",
	"./fun-time/games/page004_game1/audio/index": "6058",
	"./fun-time/games/page004_game1/audio/index.js": "6058",
	"./fun-time/games/page004_game1/config": "5d46",
	"./fun-time/games/page004_game1/config.js": "5d46",
	"./fun-time/games/page004_game1/gameData.config": "2546",
	"./fun-time/games/page004_game1/gameData.config.js": "2546",
	"./fun-time/games/page004_game1/img": "47ae",
	"./fun-time/games/page004_game1/img/": "47ae",
	"./fun-time/games/page004_game1/img/audioOff.png": "36d8",
	"./fun-time/games/page004_game1/img/audioOn.png": "6825",
	"./fun-time/games/page004_game1/img/bcg.webp": "9919",
	"./fun-time/games/page004_game1/img/bear.png": "7ca7",
	"./fun-time/games/page004_game1/img/dusty.png": "678c",
	"./fun-time/games/page004_game1/img/folia.png": "efed",
	"./fun-time/games/page004_game1/img/index": "47ae",
	"./fun-time/games/page004_game1/img/index.js": "47ae",
	"./fun-time/games/page004_game1/img/lisa.png": "9a3d",
	"./fun-time/games/page004_game1/img/mole.png": "ffa6e",
	"./fun-time/games/page004_game1/img/rabbit.png": "798a",
	"./fun-time/games/page004_game1/img/tom.png": "be84",
	"./fun-time/games/page005_game1/audio": "de7e",
	"./fun-time/games/page005_game1/audio/": "de7e",
	"./fun-time/games/page005_game1/audio/1_hello.mp3": "9701",
	"./fun-time/games/page005_game1/audio/2_bye_bye.mp3": "be97",
	"./fun-time/games/page005_game1/audio/4_Lisa.mp3": "3a2a",
	"./fun-time/games/page005_game1/audio/6_bear.mp3": "e279",
	"./fun-time/games/page005_game1/audio/7_mole.mp3": "e430",
	"./fun-time/games/page005_game1/audio/M_Brilliant.mp3": "0b68",
	"./fun-time/games/page005_game1/audio/M_Excellent.mp3": "d369",
	"./fun-time/games/page005_game1/audio/M_Fantastic.mp3": "da0e",
	"./fun-time/games/page005_game1/audio/M_Great.mp3": "0b09",
	"./fun-time/games/page005_game1/audio/M_Perfect.mp3": "78f5",
	"./fun-time/games/page005_game1/audio/M_Think again.mp3": "c7e0",
	"./fun-time/games/page005_game1/audio/M_Try again.mp3": "8552",
	"./fun-time/games/page005_game1/audio/M_Very good.mp3": "5145",
	"./fun-time/games/page005_game1/audio/M_Well done.mp3": "f560",
	"./fun-time/games/page005_game1/audio/M_Work harder.mp3": "682d",
	"./fun-time/games/page005_game1/audio/click.mp3": "50b6",
	"./fun-time/games/page005_game1/audio/false.mp3": "ac78",
	"./fun-time/games/page005_game1/audio/index": "de7e",
	"./fun-time/games/page005_game1/audio/index.js": "de7e",
	"./fun-time/games/page005_game1/audio/true.mp3": "2ee8",
	"./fun-time/games/page005_game1/config": "7c90",
	"./fun-time/games/page005_game1/config.js": "7c90",
	"./fun-time/games/page005_game1/gameData.config": "c43e",
	"./fun-time/games/page005_game1/gameData.config.js": "c43e",
	"./fun-time/games/page005_game1/img": "ec0d",
	"./fun-time/games/page005_game1/img/": "ec0d",
	"./fun-time/games/page005_game1/img/audioOff.png": "4efc",
	"./fun-time/games/page005_game1/img/audioOn.png": "244a",
	"./fun-time/games/page005_game1/img/bcg.webp": "7ad1",
	"./fun-time/games/page005_game1/img/dusty.png": "5673",
	"./fun-time/games/page005_game1/img/index": "ec0d",
	"./fun-time/games/page005_game1/img/index.js": "ec0d",
	"./fun-time/games/page005_game1/img/mole.png": "b455",
	"./fun-time/games/page005_game1/img/ramka_czerwona.png": "4c40",
	"./fun-time/games/page005_game1/img/ramka_zielona.png": "6087",
	"./fun-time/games/page005_game2/audio": "6286",
	"./fun-time/games/page005_game2/audio/": "6286",
	"./fun-time/games/page005_game2/audio/index": "6286",
	"./fun-time/games/page005_game2/audio/index.js": "6286",
	"./fun-time/games/page005_game2/config": "6f79",
	"./fun-time/games/page005_game2/config.js": "6f79",
	"./fun-time/games/page005_game2/gameData.config": "7d3d",
	"./fun-time/games/page005_game2/gameData.config.js": "7d3d",
	"./fun-time/games/page005_game2/img": "db62",
	"./fun-time/games/page005_game2/img/": "db62",
	"./fun-time/games/page005_game2/img/hello.png": "2b6b",
	"./fun-time/games/page005_game2/img/index": "db62",
	"./fun-time/games/page005_game2/img/index.js": "db62",
	"./fun-time/games/page005_game2/img/tom.png": "553e",
	"./fun-time/games/page005_game3/audio": "2c87",
	"./fun-time/games/page005_game3/audio/": "2c87",
	"./fun-time/games/page005_game3/audio/index": "2c87",
	"./fun-time/games/page005_game3/audio/index.js": "2c87",
	"./fun-time/games/page005_game3/config": "c55f",
	"./fun-time/games/page005_game3/config.js": "c55f",
	"./fun-time/games/page005_game3/gameData.config": "4117",
	"./fun-time/games/page005_game3/gameData.config.js": "4117",
	"./fun-time/games/page005_game3/img": "847e",
	"./fun-time/games/page005_game3/img/": "847e",
	"./fun-time/games/page005_game3/img/bye_bye.png": "b3ed",
	"./fun-time/games/page005_game3/img/index": "847e",
	"./fun-time/games/page005_game3/img/index.js": "847e",
	"./fun-time/games/page005_game3/img/lisa.png": "c767",
	"./fun-time/games/page005_game4/audio": "6671",
	"./fun-time/games/page005_game4/audio/": "6671",
	"./fun-time/games/page005_game4/audio/index": "6671",
	"./fun-time/games/page005_game4/audio/index.js": "6671",
	"./fun-time/games/page005_game4/config": "3bc3",
	"./fun-time/games/page005_game4/config.js": "3bc3",
	"./fun-time/games/page005_game4/gameData.config": "3693",
	"./fun-time/games/page005_game4/gameData.config.js": "3693",
	"./fun-time/games/page005_game4/img": "8add",
	"./fun-time/games/page005_game4/img/": "8add",
	"./fun-time/games/page005_game4/img/bear.png": "9a4a",
	"./fun-time/games/page005_game4/img/hello.png": "63d8",
	"./fun-time/games/page005_game4/img/index": "8add",
	"./fun-time/games/page005_game4/img/index.js": "8add",
	"./fun-time/games/page005_game5/audio": "b9f0",
	"./fun-time/games/page005_game5/audio/": "b9f0",
	"./fun-time/games/page005_game5/audio/index": "b9f0",
	"./fun-time/games/page005_game5/audio/index.js": "b9f0",
	"./fun-time/games/page005_game5/config": "3872",
	"./fun-time/games/page005_game5/config.js": "3872",
	"./fun-time/games/page005_game5/gameData.config": "036c",
	"./fun-time/games/page005_game5/gameData.config.js": "036c",
	"./fun-time/games/page005_game5/img": "785b",
	"./fun-time/games/page005_game5/img/": "785b",
	"./fun-time/games/page005_game5/img/index": "785b",
	"./fun-time/games/page005_game5/img/index.js": "785b",
	"./fun-time/games/page005_game5/img/lisa.png": "4426",
	"./fun-time/games/page005_game5/img/mole.png": "eec9",
	"./fun-time/games/page006_game0/audio": "4119",
	"./fun-time/games/page006_game0/audio/": "4119",
	"./fun-time/games/page006_game0/audio/10_yellow.mp3": "1320",
	"./fun-time/games/page006_game0/audio/11_green.mp3": "93d5",
	"./fun-time/games/page006_game0/audio/8_blue.mp3": "e7a3",
	"./fun-time/games/page006_game0/audio/9_red.mp3": "32f7",
	"./fun-time/games/page006_game0/audio/M_Brilliant.mp3": "9f36",
	"./fun-time/games/page006_game0/audio/M_Excellent.mp3": "3824",
	"./fun-time/games/page006_game0/audio/M_Fantastic.mp3": "811c",
	"./fun-time/games/page006_game0/audio/M_Great.mp3": "d63e",
	"./fun-time/games/page006_game0/audio/M_Perfect.mp3": "470c",
	"./fun-time/games/page006_game0/audio/M_Think again.mp3": "0cf6",
	"./fun-time/games/page006_game0/audio/M_Try again.mp3": "a34b",
	"./fun-time/games/page006_game0/audio/M_Very good.mp3": "3ae1",
	"./fun-time/games/page006_game0/audio/M_Well done.mp3": "73b5",
	"./fun-time/games/page006_game0/audio/M_Work harder.mp3": "e7a30",
	"./fun-time/games/page006_game0/audio/click.mp3": "fb68",
	"./fun-time/games/page006_game0/audio/index": "4119",
	"./fun-time/games/page006_game0/audio/index.js": "4119",
	"./fun-time/games/page006_game0/config": "aacc",
	"./fun-time/games/page006_game0/config.js": "aacc",
	"./fun-time/games/page006_game0/gameData.config": "939a",
	"./fun-time/games/page006_game0/gameData.config.js": "939a",
	"./fun-time/games/page006_game0/img": "26c0",
	"./fun-time/games/page006_game0/img/": "26c0",
	"./fun-time/games/page006_game0/img/audioOff.png": "caa9",
	"./fun-time/games/page006_game0/img/audioOn.png": "d3ef",
	"./fun-time/games/page006_game0/img/bcg.webp": "2da9",
	"./fun-time/games/page006_game0/img/index": "26c0",
	"./fun-time/games/page006_game0/img/index.js": "26c0",
	"./fun-time/games/page006_game0/img/tubka_b.png": "bc02",
	"./fun-time/games/page006_game0/img/tubka_g.png": "0dcb",
	"./fun-time/games/page006_game0/img/tubka_r.png": "ada5",
	"./fun-time/games/page006_game0/img/tubka_y.png": "d5be",
	"./fun-time/games/page006_game1/audio": "5b9a",
	"./fun-time/games/page006_game1/audio/": "5b9a",
	"./fun-time/games/page006_game1/audio/10_yellow.mp3": "d737",
	"./fun-time/games/page006_game1/audio/11_green.mp3": "4b2a",
	"./fun-time/games/page006_game1/audio/8_blue.mp3": "cdb8",
	"./fun-time/games/page006_game1/audio/9_red.mp3": "c66c",
	"./fun-time/games/page006_game1/audio/M_Brilliant.mp3": "d169",
	"./fun-time/games/page006_game1/audio/M_Excellent.mp3": "cf15",
	"./fun-time/games/page006_game1/audio/M_Fantastic.mp3": "9a9a",
	"./fun-time/games/page006_game1/audio/M_Great.mp3": "dff0",
	"./fun-time/games/page006_game1/audio/M_Perfect.mp3": "18fd",
	"./fun-time/games/page006_game1/audio/M_Think again.mp3": "66b6",
	"./fun-time/games/page006_game1/audio/M_Try again.mp3": "b6a0",
	"./fun-time/games/page006_game1/audio/M_Very good.mp3": "9bfa",
	"./fun-time/games/page006_game1/audio/M_Well done.mp3": "81fc",
	"./fun-time/games/page006_game1/audio/M_Work harder.mp3": "a878",
	"./fun-time/games/page006_game1/audio/click.mp3": "1d41",
	"./fun-time/games/page006_game1/audio/index": "5b9a",
	"./fun-time/games/page006_game1/audio/index.js": "5b9a",
	"./fun-time/games/page006_game1/config": "f85d",
	"./fun-time/games/page006_game1/config.js": "f85d",
	"./fun-time/games/page006_game1/gameData.config": "d046",
	"./fun-time/games/page006_game1/gameData.config.js": "d046",
	"./fun-time/games/page006_game1/img": "ca62",
	"./fun-time/games/page006_game1/img/": "ca62",
	"./fun-time/games/page006_game1/img/1.png": "c16a",
	"./fun-time/games/page006_game1/img/2.png": "8da1",
	"./fun-time/games/page006_game1/img/3.png": "1ad9",
	"./fun-time/games/page006_game1/img/4.png": "f0b2",
	"./fun-time/games/page006_game1/img/audioOff.png": "2f8c",
	"./fun-time/games/page006_game1/img/audioOn.png": "3a8a",
	"./fun-time/games/page006_game1/img/bcg.webp": "11b4",
	"./fun-time/games/page006_game1/img/index": "ca62",
	"./fun-time/games/page006_game1/img/index.js": "ca62",
	"./fun-time/games/page006_game1/img/tubka_b.png": "9030",
	"./fun-time/games/page006_game1/img/tubka_g.png": "2ed7",
	"./fun-time/games/page006_game1/img/tubka_r.png": "9e93",
	"./fun-time/games/page006_game1/img/tubka_y.png": "f2b1",
	"./fun-time/games/page007_game0/audio": "978c",
	"./fun-time/games/page007_game0/audio/": "978c",
	"./fun-time/games/page007_game0/audio/M_Brilliant.mp3": "e397",
	"./fun-time/games/page007_game0/audio/M_Excellent.mp3": "2b9f",
	"./fun-time/games/page007_game0/audio/M_Fantastic.mp3": "7ef5",
	"./fun-time/games/page007_game0/audio/M_Great.mp3": "e0c4",
	"./fun-time/games/page007_game0/audio/M_Perfect.mp3": "7f75",
	"./fun-time/games/page007_game0/audio/M_Think again.mp3": "0476",
	"./fun-time/games/page007_game0/audio/M_Try again.mp3": "740f",
	"./fun-time/games/page007_game0/audio/M_Very good.mp3": "f6ae",
	"./fun-time/games/page007_game0/audio/M_Well done.mp3": "2707",
	"./fun-time/games/page007_game0/audio/M_Work harder.mp3": "e79d",
	"./fun-time/games/page007_game0/audio/index": "978c",
	"./fun-time/games/page007_game0/audio/index.js": "978c",
	"./fun-time/games/page007_game0/config": "d701",
	"./fun-time/games/page007_game0/config.js": "d701",
	"./fun-time/games/page007_game0/gameData.config": "bf8c",
	"./fun-time/games/page007_game0/gameData.config.js": "bf8c",
	"./fun-time/games/page007_game0/img": "356c",
	"./fun-time/games/page007_game0/img/": "356c",
	"./fun-time/games/page007_game0/img/index": "356c",
	"./fun-time/games/page007_game0/img/index.js": "356c",
	"./fun-time/games/page007_game0/img/mask.png": "4f79",
	"./fun-time/games/page007_game0/img/t1.webp": "c8b2",
	"./fun-time/games/page008_game1/audio": "b15f",
	"./fun-time/games/page008_game1/audio/": "b15f",
	"./fun-time/games/page008_game1/audio/11_green.mp3": "8be9",
	"./fun-time/games/page008_game1/audio/12_purple.mp3": "0b75",
	"./fun-time/games/page008_game1/audio/14_orange.mp3": "c404",
	"./fun-time/games/page008_game1/audio/9_red.mp3": "8d0c",
	"./fun-time/games/page008_game1/audio/M_Brilliant.mp3": "1b7e",
	"./fun-time/games/page008_game1/audio/M_Excellent.mp3": "0f53",
	"./fun-time/games/page008_game1/audio/M_Fantastic.mp3": "0e2e",
	"./fun-time/games/page008_game1/audio/M_Great.mp3": "cbf7",
	"./fun-time/games/page008_game1/audio/M_Perfect.mp3": "8ce5",
	"./fun-time/games/page008_game1/audio/M_Think again.mp3": "2bc0",
	"./fun-time/games/page008_game1/audio/M_Try again.mp3": "cbe0",
	"./fun-time/games/page008_game1/audio/M_Very good.mp3": "8fe5",
	"./fun-time/games/page008_game1/audio/M_Well done.mp3": "01b7",
	"./fun-time/games/page008_game1/audio/M_Work harder.mp3": "4b5e",
	"./fun-time/games/page008_game1/audio/click.mp3": "6291",
	"./fun-time/games/page008_game1/audio/false.mp3": "6586",
	"./fun-time/games/page008_game1/audio/index": "b15f",
	"./fun-time/games/page008_game1/audio/index.js": "b15f",
	"./fun-time/games/page008_game1/audio/true.mp3": "16c9",
	"./fun-time/games/page008_game1/config": "82aa",
	"./fun-time/games/page008_game1/config.js": "82aa",
	"./fun-time/games/page008_game1/gameData.config": "13d4",
	"./fun-time/games/page008_game1/gameData.config.js": "13d4",
	"./fun-time/games/page008_game1/img": "4e86",
	"./fun-time/games/page008_game1/img/": "4e86",
	"./fun-time/games/page008_game1/img/audioOff.png": "24df",
	"./fun-time/games/page008_game1/img/audioOn.png": "e8ae",
	"./fun-time/games/page008_game1/img/bcg.webp": "fc98",
	"./fun-time/games/page008_game1/img/cup_blue.png": "db4a",
	"./fun-time/games/page008_game1/img/cup_red.png": "4ea6",
	"./fun-time/games/page008_game1/img/folia.png": "f314",
	"./fun-time/games/page008_game1/img/index": "4e86",
	"./fun-time/games/page008_game1/img/index.js": "4e86",
	"./fun-time/games/page008_game1/img/ramka_czerwona.png": "5936",
	"./fun-time/games/page008_game1/img/ramka_zielona.png": "36b4",
	"./fun-time/games/page008_game2/audio": "8388",
	"./fun-time/games/page008_game2/audio/": "8388",
	"./fun-time/games/page008_game2/audio/index": "8388",
	"./fun-time/games/page008_game2/audio/index.js": "8388",
	"./fun-time/games/page008_game2/config": "8ea1",
	"./fun-time/games/page008_game2/config.js": "8ea1",
	"./fun-time/games/page008_game2/gameData.config": "4669",
	"./fun-time/games/page008_game2/gameData.config.js": "4669",
	"./fun-time/games/page008_game2/img": "88de",
	"./fun-time/games/page008_game2/img/": "88de",
	"./fun-time/games/page008_game2/img/bcg.webp": "1e78",
	"./fun-time/games/page008_game2/img/cup_green.png": "3529",
	"./fun-time/games/page008_game2/img/cup_pink.png": "49ef",
	"./fun-time/games/page008_game2/img/index": "88de",
	"./fun-time/games/page008_game2/img/index.js": "88de",
	"./fun-time/games/page008_game3/audio": "9e82",
	"./fun-time/games/page008_game3/audio/": "9e82",
	"./fun-time/games/page008_game3/audio/index": "9e82",
	"./fun-time/games/page008_game3/audio/index.js": "9e82",
	"./fun-time/games/page008_game3/config": "748a",
	"./fun-time/games/page008_game3/config.js": "748a",
	"./fun-time/games/page008_game3/gameData.config": "e7dd",
	"./fun-time/games/page008_game3/gameData.config.js": "e7dd",
	"./fun-time/games/page008_game3/img": "89e0",
	"./fun-time/games/page008_game3/img/": "89e0",
	"./fun-time/games/page008_game3/img/bcg.webp": "d3f9",
	"./fun-time/games/page008_game3/img/cup_blue.png": "2d26",
	"./fun-time/games/page008_game3/img/cup_orange.png": "b921",
	"./fun-time/games/page008_game3/img/index": "89e0",
	"./fun-time/games/page008_game3/img/index.js": "89e0",
	"./fun-time/games/page008_game4/audio": "e998",
	"./fun-time/games/page008_game4/audio/": "e998",
	"./fun-time/games/page008_game4/audio/index": "e998",
	"./fun-time/games/page008_game4/audio/index.js": "e998",
	"./fun-time/games/page008_game4/config": "1933",
	"./fun-time/games/page008_game4/config.js": "1933",
	"./fun-time/games/page008_game4/gameData.config": "76a4",
	"./fun-time/games/page008_game4/gameData.config.js": "76a4",
	"./fun-time/games/page008_game4/img": "729c",
	"./fun-time/games/page008_game4/img/": "729c",
	"./fun-time/games/page008_game4/img/bcg.webp": "d6d1",
	"./fun-time/games/page008_game4/img/cup_purple.png": "5b45",
	"./fun-time/games/page008_game4/img/cup_yellow.png": "c381",
	"./fun-time/games/page008_game4/img/index": "729c",
	"./fun-time/games/page008_game4/img/index.js": "729c",
	"./fun-time/games/page009_game0/audio": "1b45",
	"./fun-time/games/page009_game0/audio/": "1b45",
	"./fun-time/games/page009_game0/audio/10_yellow.mp3": "5cda",
	"./fun-time/games/page009_game0/audio/11_green.mp3": "fa88",
	"./fun-time/games/page009_game0/audio/13_pink.mp3": "5300",
	"./fun-time/games/page009_game0/audio/14_orange.mp3": "f0d9",
	"./fun-time/games/page009_game0/audio/8_blue.mp3": "f8dd",
	"./fun-time/games/page009_game0/audio/M_Brilliant.mp3": "05bc",
	"./fun-time/games/page009_game0/audio/M_Excellent.mp3": "0daf",
	"./fun-time/games/page009_game0/audio/M_Fantastic.mp3": "5d8f",
	"./fun-time/games/page009_game0/audio/M_Great.mp3": "0d93",
	"./fun-time/games/page009_game0/audio/M_Perfect.mp3": "1f52",
	"./fun-time/games/page009_game0/audio/M_Think again.mp3": "37bc",
	"./fun-time/games/page009_game0/audio/M_Try again.mp3": "6130",
	"./fun-time/games/page009_game0/audio/M_Very good.mp3": "64fe",
	"./fun-time/games/page009_game0/audio/M_Well done.mp3": "3e76",
	"./fun-time/games/page009_game0/audio/M_Work harder.mp3": "f968",
	"./fun-time/games/page009_game0/audio/click.mp3": "6fa6",
	"./fun-time/games/page009_game0/audio/false.mp3": "3198",
	"./fun-time/games/page009_game0/audio/index": "1b45",
	"./fun-time/games/page009_game0/audio/index.js": "1b45",
	"./fun-time/games/page009_game0/audio/true.mp3": "47dc",
	"./fun-time/games/page009_game0/config": "787f",
	"./fun-time/games/page009_game0/config.js": "787f",
	"./fun-time/games/page009_game0/gameData.config": "0acb",
	"./fun-time/games/page009_game0/gameData.config.js": "0acb",
	"./fun-time/games/page009_game0/img": "6441",
	"./fun-time/games/page009_game0/img/": "6441",
	"./fun-time/games/page009_game0/img/img_m.png": "81ca",
	"./fun-time/games/page009_game0/img/img_o.png": "c603",
	"./fun-time/games/page009_game0/img/img_t.webp": "e55f",
	"./fun-time/games/page009_game0/img/index": "6441",
	"./fun-time/games/page009_game0/img/index.js": "6441",
	"./fun-time/games/page010_game0/audio": "a0a3",
	"./fun-time/games/page010_game0/audio/": "a0a3",
	"./fun-time/games/page010_game0/audio/10_yellow.mp3": "baab",
	"./fun-time/games/page010_game0/audio/11_green.mp3": "8163",
	"./fun-time/games/page010_game0/audio/12_purple.mp3": "236c",
	"./fun-time/games/page010_game0/audio/13_pink.mp3": "3015",
	"./fun-time/games/page010_game0/audio/14_orange.mp3": "2075",
	"./fun-time/games/page010_game0/audio/1_hello.mp3": "36b2",
	"./fun-time/games/page010_game0/audio/2_bye_bye.mp3": "6ba6",
	"./fun-time/games/page010_game0/audio/3_Tom.mp3": "6c5b",
	"./fun-time/games/page010_game0/audio/4_Lisa.mp3": "47c4",
	"./fun-time/games/page010_game0/audio/5_rabbit.mp3": "a8f06",
	"./fun-time/games/page010_game0/audio/6_bear.mp3": "55f2",
	"./fun-time/games/page010_game0/audio/7_mole.mp3": "929b",
	"./fun-time/games/page010_game0/audio/8_blue.mp3": "9107",
	"./fun-time/games/page010_game0/audio/9_red.mp3": "a838",
	"./fun-time/games/page010_game0/audio/M_Brilliant.mp3": "0b6e",
	"./fun-time/games/page010_game0/audio/M_Excellent.mp3": "b12c",
	"./fun-time/games/page010_game0/audio/M_Fantastic.mp3": "805a",
	"./fun-time/games/page010_game0/audio/M_Great.mp3": "6407",
	"./fun-time/games/page010_game0/audio/M_Perfect.mp3": "90d6",
	"./fun-time/games/page010_game0/audio/M_Think again.mp3": "25a9",
	"./fun-time/games/page010_game0/audio/M_Try again.mp3": "8b52",
	"./fun-time/games/page010_game0/audio/M_Very good.mp3": "9cfe",
	"./fun-time/games/page010_game0/audio/M_Well done.mp3": "d48a",
	"./fun-time/games/page010_game0/audio/M_Work harder.mp3": "9c2e",
	"./fun-time/games/page010_game0/audio/click.mp3": "5b30",
	"./fun-time/games/page010_game0/audio/index": "a0a3",
	"./fun-time/games/page010_game0/audio/index.js": "a0a3",
	"./fun-time/games/page010_game0/config": "c192",
	"./fun-time/games/page010_game0/config.js": "c192",
	"./fun-time/games/page010_game0/gameData.config": "8227",
	"./fun-time/games/page010_game0/gameData.config.js": "8227",
	"./fun-time/games/page010_game0/img": "585e",
	"./fun-time/games/page010_game0/img/": "585e",
	"./fun-time/games/page010_game0/img/audioOff.png": "fcbd",
	"./fun-time/games/page010_game0/img/audioOn.png": "8392d",
	"./fun-time/games/page010_game0/img/bcg.webp": "0618",
	"./fun-time/games/page010_game0/img/bear.png": "dabf",
	"./fun-time/games/page010_game0/img/blue.png": "7f01",
	"./fun-time/games/page010_game0/img/bye_bye.png": "c738",
	"./fun-time/games/page010_game0/img/green.png": "bf4b",
	"./fun-time/games/page010_game0/img/hello.png": "0f10",
	"./fun-time/games/page010_game0/img/index": "585e",
	"./fun-time/games/page010_game0/img/index.js": "585e",
	"./fun-time/games/page010_game0/img/lisa.png": "4bbf",
	"./fun-time/games/page010_game0/img/mole.png": "4cc1",
	"./fun-time/games/page010_game0/img/orange.png": "fff5",
	"./fun-time/games/page010_game0/img/pink.png": "2c60",
	"./fun-time/games/page010_game0/img/purple.png": "4bb1",
	"./fun-time/games/page010_game0/img/rabbit.png": "03fa1",
	"./fun-time/games/page010_game0/img/red.png": "dee7",
	"./fun-time/games/page010_game0/img/tom.png": "e708",
	"./fun-time/games/page010_game0/img/yellow.png": "b39b",
	"./fun-time/presentation": "f9a2",
	"./fun-time/presentation/": "f9a2",
	"./fun-time/presentation/index": "f9a2",
	"./fun-time/presentation/index.js": "f9a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d8a4";